import React, { FC } from 'react';
import { Typography, Box } from '@mui/material';
import { OrderEvent } from 'models/order-event';
import { NavLink } from 'react-router-dom';

type EventRecordTitleProps = {
    title: string;
    item: OrderEvent;
    color: 'colorOne' | 'colorTwo' | 'colorThree';
    displayOrderLabel?: boolean;
};
const EventRecordTitle: FC<EventRecordTitleProps> = ({
    title,
    item,
    color,
    displayOrderLabel = false,
}: EventRecordTitleProps) => {
    const orderDetailsUrl = `/order-details/${item.orderDbId}/main-view`;

    const getColor = (color: 'colorOne' | 'colorTwo' | 'colorThree') => {
        switch (color) {
            case 'colorOne':
                return '#9e2b64';
            case 'colorTwo':
                return '#1f870c';
            case 'colorThree':
                return '#3e39bf';
        }
    };

    return (
        <Box display="flex" alignItems="center">
            <Box flex="1 1 auto">
                <Typography variant="subtitle2">{title}</Typography>
            </Box>
            {displayOrderLabel ? (
                <Box
                    sx={(theme) => ({
                        paddingLeft: theme.spacing(1),
                        paddingRight: theme.spacing(1),
                        borderRadius: theme.shape.borderRadius,
                        cursor: 'pointer',
                        background: getColor(color),
                        color: '#fff',
                        '& a': {
                            color: '#fff',
                            textDecoration: 'none',
                        },
                    })}
                >
                    <NavLink to={orderDetailsUrl}>{item.orderId}</NavLink>
                </Box>
            ) : undefined}
        </Box>
    );
};

export default EventRecordTitle;
